import { requests } from "App/api/agent/agent";

export const ProxyApi = {
    getFacebookPageByUrl: (body: GetFacebookPageByUrlRequest): Promise<string> => requests.post(`/proxy/facebook/url`, body),
}